import $ from 'jquery';
import React from 'react';
import PropTypes from 'prop-types';
import { CivilDate } from 'tc39-proposal-temporal';
import ReportingProps from '@bingads-webui-campaign-react/props-reporting';
import { SingleMonthCalendar } from '@bingads-webui-react/single-month-calendar';
import { Input } from '@bingads-webui-react/primitive-validation';
import { keyCode } from '@bingads-webui/keycode';
import { getCivilDateToday } from '@bingads-webui-universal/temporal-utitlities';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { inputTitleStyle } from './styles/input-title-style';

class StartEndDate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startNavigatedDate: '',
      endNavigatedDate: '',
      startSelectedDate: '',
      endSelectedDate: '',
      isShowStartDatePicker: false,
      isShowEndDatePicker: false,
      selectedRanges: [],
    };
    this.startDateInputRef = React.createRef();
    this.endDateInputRef = React.createRef();
  }

  componentDidMount() {
    this.startDateInputRef.addEventListener('mousedown', this.handelShowHideSingleDatePicker);
    this.endDateInputRef.addEventListener('mousedown', this.handelShowHideSingleDatePicker);
    this.onValidate();
  }

  componentWillUnmount() {
    this.startDateInputRef.removeEventListener('mousedown', this.handelShowHideSingleDatePicker);
    this.endDateInputRef.removeEventListener('mousedown', this.handelShowHideSingleDatePicker);
  }

  static getDerivedStateFromProps(props) {
    const startDate = new Date(props.startDate);
    const startSelectedDate = new CivilDate(
      startDate.getUTCFullYear(),
      startDate.getUTCMonth() + 1,
      startDate.getUTCDate()
    );
    const endDate = new Date(props.endDate);
    const endSelectedDate = new CivilDate(
      endDate.getUTCFullYear(),
      endDate.getUTCMonth() + 1,
      endDate.getUTCDate()
    );
    return {
      startSelectedDate,
      startNavigatedDate: startSelectedDate,
      endSelectedDate,
      endNavigatedDate: endSelectedDate,
      selectedRanges: [{
        start: startSelectedDate,
        end: endSelectedDate,
      }],
    };
  }

  onSelectDate = (date) => {
    if (this.state.isShowStartDatePicker) {
      this.setState({
        startSelectedDate: date,
        isShowStartDatePicker: false,
      }, this.onValidate);
      this.props.changeStartEndDate({
        StartTime: date.toString(),
      });
    } else if (this.state.isShowEndDatePicker) {
      this.setState({
        endSelectedDate: date,
        isShowEndDatePicker: false,
      }, this.onValidate);
      this.props.changeStartEndDate({
        EndTime: date.toString(),
      });
    }
  }

  onValidate = () => {
    const today = new Date();
    const start = this.state.startSelectedDate;
    const end = this.state.endSelectedDate;

    if (start > end) {
      this.setState({
        errMessage: _TL_('The start date for the scheduled report cannot be later than the end date.'),
      });
    } else if (today > new Date(end.year, end.month - 1, end.day)) {
      this.setState({
        errMessage: _TL_('The end date for a scheduled report must be greater than the current date.'),
      });
    } else {
      this.setState({
        errMessage: false,
      });
    }
  }

  onKeyDown = (event) => {
    if (event.keyCode === keyCode.Enter) {
      this.handelShowHideSingleDatePicker(event);
    }
  }

  setWrapperRef = (node) => {
    this.wrapperRef = node;
  }

  handelShowHideSingleDatePicker = (event) => {
    if (event.target === $('#startDateInput')[0]) {
      this.setState({
        isShowStartDatePicker: !this.state.isShowStartDatePicker,
        isShowEndDatePicker: false,
      });
    } else if (event.target === $('#endDateInput')[0]) {
      this.setState({
        isShowStartDatePicker: false,
        isShowEndDatePicker: !this.state.isShowEndDatePicker,
      });
    } else if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({
        isShowStartDatePicker: false,
        isShowEndDatePicker: false,
      });
    }
  }

  render() {
    const {
      i18n, classes, isScheduleEnabled,
    } = this.props;
    const minDate = getCivilDateToday().plus({ days: -1 });
    const maxDate = getCivilDateToday().plus({ years: 2 });

    return (
      <div className={classes.startEndDate} id="startEndDate">
        <div id="startDatePicker">
          <div id="startDateLabel" className={classes.startEndDateLabel}> {i18n.getString(_TL_('Start Date'))}</div>
          <div>
            <Input
              disabled={!isScheduleEnabled}
              readOnly
              id="startDateInput"
              onKeyDown={this.onKeyDown}
              value={i18n.formatCivilDate(this.state.startSelectedDate, { skeleton: 'yMd' })}
              aria-labelledby="startDateLabel"
              inputRef={(ref) => { this.startDateInputRef = ref; }}
            />
            {
              this.state.isShowStartDatePicker &&
              <div className={classes.calenderWrapper} ref={this.setWrapperRef}>
                <SingleMonthCalendar
                  minDate={minDate}
                  maxDate={maxDate}
                  defaultNavigatedDate={getCivilDateToday()}
                  defaultSelectedDate={getCivilDateToday()}
                  today={getCivilDateToday()}
                  selectedRanges={this.state.selectedRanges}
                  navigatedDate={this.state.startNavigatedDate}
                  selectedDate={this.state.startSelectedDate}
                  onSelectDate={date => this.onSelectDate(date)}
                  i18n={i18n}
                  isMonthPickerEnabled
                />
              </div>
            }
          </div>
        </div>
        <div id="endDatePicker" >
          <div id="endDateLabel" className={classes.startEndDateLabel}> {i18n.getString(_TL_('End Date'))}</div>
          <div>
            <Input
              disabled={!isScheduleEnabled}
              readOnly
              id="endDateInput"
              onKeyDown={this.onKeyDown}
              value={i18n.formatCivilDate(this.state.endSelectedDate, { skeleton: 'yMd' })}
              aria-labelledby="endDateLabel"
              inputRef={(ref) => { this.endDateInputRef = ref; }}
            />
            {
              this.state.isShowEndDatePicker &&
              <div className={classes.calenderWrapper} ref={this.setWrapperRef}>
                <SingleMonthCalendar
                  minDate={this.state.startSelectedDate.plus({ days: -1 })}
                  maxDate={maxDate}
                  defaultNavigatedDate={getCivilDateToday()}
                  defaultSelectedDate={getCivilDateToday()}
                  today={getCivilDateToday()}
                  selectedRanges={this.state.selectedRanges}
                  navigatedDate={this.state.endNavigatedDate}
                  selectedDate={this.state.endSelectedDate}
                  onSelectDate={this.onSelectDate}
                  i18n={i18n}
                  isMonthPickerEnabled
                />
              </div>
            }
          </div>
        </div>
        {
          this.state.errMessage ?
            <p className={classes.errorMsg} id="start-end-error">
              {i18n.getString(this.state.errMessage)}
            </p> : ''
        }
      </div>
    );
  }
}

StartEndDate.propTypes = {
  isScheduleEnabled: PropTypes.bool.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  i18n: ReportingProps.i18n.isRequired,
  changeStartEndDate: PropTypes.func.isRequired,
};

const StyledStartEndDate = withDefaultStyles(StartEndDate, (components, core) => ({
  calenderWrapper: {
    position: 'relative',
  },
  startEndDateLabel: inputTitleStyle(components, core),
  startEndDate: {
    '& input[readonly][disabled]': {
      backgroundColor: '#f3f2f1',
    },
    display: 'flex',
    paddingTop: '0px',
    '& > div': {
      float: 'left',
      display: 'flex',
      width: '135px',
    },
    '& #startDatePicker': {
      marginRight: '10px',
    },
  },
  errorMsg: {
    color: '#D90026',
    position: 'absolute',
    top: '50px',
  },
}));

export { StyledStartEndDate as StartEndDate };
